import React from 'react';
import './StepApproval.scss';
import BaseComponent from '../../../../../baseClasses/BaseComponent';

class stepApproval extends BaseComponent {
  constructor(props) {
    super(props);
    this.clicked = false;
  }
  handleStepApprove(e) {

  }
  handleStepReject(e) {
    if (!this.clicked) { 
      this.clicked = true; 
      this.props.handleStepReject(e); 
    }
  }
  render() {
    const { userStepPermissions } = this.props;
    let buttonText = '';
    let className = '';
    if (userStepPermissions.has('is_approver')) {
      buttonText = 'Approve';
      className = 'approve';
    }
    else {
      buttonText = 'Review';
      className = 'review';
    }

    return (
      <div className="step-approval">
        <button onClick={this.handleStepReject} className="reject">Reject</button>
        <button onClick={e => { if (!this.clicked) { this.clicked = true; this.props.handleStepApprove(e); } }} className={className}>{buttonText}</button>
      </div>
    );
  }
}

export default stepApproval;



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskCompletionStepsContainer/TaskCompletionSteps/StepApproval/index.js